// extracted by mini-css-extract-plugin
export default {"mapCloseButton":"ScoreCardList_mapCloseButton__t-yjA","map":"ScoreCardList_map__VsIs4"};